import { render } from "./AdminUsuarios.vue?vue&type=template&id=33661264&scoped=true"
import script from "./AdminUsuarios.vue?vue&type=script&lang=js"
export * from "./AdminUsuarios.vue?vue&type=script&lang=js"

import "./AdminUsuarios.vue?vue&type=style&index=0&id=33661264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33661264"]])

export default __exports__